import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, CheckCircle2, XCircle, Pencil, Send, Loader2, Search } from "lucide-react";
import { api } from "@/lib/api";

const STATUS = {
  pending: { icon: Clock, cls: "text-qi-gold bg-qi-gold/10 border-qi-gold/30", label: "Pending review", note: "We're reviewing your application. Once approved you can chat with QIs and send referrals." },
  approved: { icon: CheckCircle2, cls: "text-qi-emerald bg-qi-emerald/10 border-qi-emerald/30", label: "Approved member", note: "Open any QI's profile to start a chat or send a client referral." },
  rejected: { icon: XCircle, cls: "text-red-400 bg-red-500/10 border-red-500/30", label: "Not approved", note: "Your application wasn't approved. Update your details and contact support." },
};
const REF_STATUS = { new: "Sent", contacted: "QI contacted client", closed: "Closed" };

const Referrals = () => {
  const [refs, setRefs] = useState(null);
  useEffect(() => {
    api.get("/me/referrals").then(({ data }) => setRefs(data)).catch(() => setRefs([]));
  }, []);
  return (
    <div className="glass-card overflow-hidden" data-testid="partner-referrals">
      <div className="p-6 border-b border-white/10 flex items-center gap-3"><Send size={18} className="text-qi-pink" /><h3 className="font-display text-lg font-bold">Referrals you've sent</h3>
        <span className="font-mono text-xs text-white/40 ml-auto">{refs?.length || 0} total</span></div>
      {refs === null ? <div className="p-10 flex justify-center"><Loader2 className="animate-spin text-qi-pink" /></div>
        : refs.length === 0 ? <p className="p-10 text-center text-sm text-white/40" data-testid="partner-referrals-empty">No referrals yet. Open a QI's profile and tap "Send a referral".</p>
          : refs.map((r) => (
            <div key={r.lead_id} className="p-5 border-b border-white/5 last:border-0 flex flex-wrap items-center gap-3" data-testid={`partner-referral-${r.lead_id}`}>
              <div className="flex-1 min-w-0">
                <p className="font-bold">{r.name}</p>
                <p className="text-xs text-white/50 mt-1">to {r.qi?.slug ? <Link to={`/qi/${r.qi.slug}`} className="text-qi-pink">{r.qi.company_name}</Link> : r.qi?.company_name || "QI"} · {new Date(r.created_at).toLocaleDateString()}</p>
              </div>
              <span className="text-[11px] font-mono bg-white/5 rounded-full px-3 py-1">{REF_STATUS[r.status]}</span>
            </div>
          ))}
    </div>
  );
};

export const PartnerDashboard = ({ partner }) => {
  const s = STATUS[partner.status];
  return (
    <>
      <div className="glass-card p-7 flex flex-col md:flex-row md:items-center gap-6" data-testid="partner-profile-card">
        <div className="flex-1 min-w-0">
          <span className="eyebrow">Referral partner · {partner.profession}</span>
          <h2 className="font-display text-2xl font-black mt-2">{partner.firm}</h2>
          <span data-testid="partner-status" className={`inline-flex items-center gap-1.5 mt-2 text-xs font-bold rounded-full px-3 py-1 border ${s.cls}`}><s.icon size={13} />{s.label}</span>
          <p className="text-sm text-white/50 mt-3">{s.note}</p>
        </div>
        <div className="flex gap-3">
          <Link to="/partner-intake" className="btn-ghost !py-2.5 text-sm" data-testid="partner-edit-button"><Pencil size={14} /> Edit</Link>
          {partner.status === "approved" && <Link to="/directory" className="btn-pink !py-2.5 text-sm" data-testid="partner-find-qi-button"><Search size={14} /> Find a QI</Link>}
        </div>
      </div>
      <Referrals />
    </>
  );
};
